module.exports = __webpack_public_path__ + "img/pr-3.24780ae9.png";